import axios from "axios";
import interceptors from "@/shared/api/interceptors";

const apiClientFc = axios.create({
  baseURL: window.__CONFIG__.VUE_APP_BASE_DOMAIN + "/fc",
  withCredentials: true,
});

interceptors(apiClientFc);

export default apiClientFc;
